import { render, staticRenderFns } from "./ModalHistoricoStatus.vue?vue&type=template&id=60333e8e"
import script from "./ModalHistoricoStatus.vue?vue&type=script&lang=js"
export * from "./ModalHistoricoStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports